export default __webpack_public_path__ + "static/media/client_img5.57f6531f.png";